<div class="dasboard-width">
  <div class="row header mar-lft-rgt-0" style="padding-bottom: 0px">

    <div class="col-md-6">View Tickets</div>

    <div class="col-md-6">
      <!--      <ol class="breadcrumb cust-bread">-->
      <!--        <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting('dashboard')"><i-->
      <!--          class="fa fa-dashboard"></i> Home</a></li>-->
      <!--        <li class="breadcrumb-item active" aria-current="page">View tickets</li>-->
      <!--      </ol>-->
      <mat-form-field>
        <mat-label>Current Role:</mat-label>
        <mat-select [(ngModel)]="userGroupSelected" (selectionChange)="onSelectGroup()">
          <mat-option *ngFor="let group of userGroups" [value]="group.groupId"
          >{{group.grpName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row content mr-top-5 mar-lft-rgt-0">
    <div class="col-md-3">
      <div class="views-title">
        Views
      </div>
      <div class="views-body">
        Modules
        <button class="btn btn-light" (click)="toggleViews()"><i class="fa "
                                                                 [ngClass]="displayed?'fa-minus':'fa-plus'"></i>
        </button>
      </div>
      <div class="views-body" [hidden]="!displayed">
        <div class="height-40" [hidden]="ticketTypeLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <mat-radio-group (change)="onButtonChange($event)">
          <mat-radio-button *ngFor="let button of types;" [value]="button"
                            [checked]="button.checked">{{button.name}}</mat-radio-button>
        </mat-radio-group>
        <br>
      </div>
      <div class="views-body mar-top-15">
        Folders
        <button class="btn btn-light" (click)="toggleFolderViews()"><i class="fa "
                                                                       [ngClass]="folderDisplayed?'fa-minus':'fa-plus'"></i>
        </button>
      </div>
      <div [hidden]="!folderDisplayed">
        <div class="loader-img height-120" [hidden]="folderLoaded">
          <img class="loading-gif-70" src="../../../assets/img/loader-70px.gif">
        </div>
        <ul class="folders">
          <li *ngFor="let menu of menus;" [ngClass]="{activeF: step===menu.fid}"
              (click)="step=menu.fid;folderClick(step)">
            <i class="fa fa-filter"></i>
            {{menu.funcDescription}}
          </li>
        </ul>

        <!--<input type="text" class="form-control inline radius-0 font-13 " placeholder="RS Code..">-->
        <!--<button type="button" class="btn btn-success radius-0 font-13 mar-lft-2">GO</button>-->
        <input type="text" class="form-control inline radius-0 font-13 mar-top-1" placeholder="Ticket No..">
        <button type="button" class="btn btn-success radius-0 font-13 mar-lft-2 mar-top-1">GO</button>


      </div>

    </div>
    <div class="col-md-9">
      <div class="card">
        <div class="card-header card-header-top">
          View Tickets
          <div class="pull-right none font-13" [ngClass]="{'block':show}">(Selected items:<span>{{selected}}</span>)
          </div>
          <div class="pull-right font-13">
            <b>Total items: </b> <span>{{totalItems}}</span>
          </div>
        </div>
        <div class="card-body card-body-grid">
          <!--<ngb-pagination (pageChange)="onPager($event)" [collectionSize]="collectionSize" [(page)]="page" size="sm" [maxSize]="MAX_SIZE"-->
          <!--[rotate]="true" [disabled]='isDisabled' [boundaryLinks]="true"></ngb-pagination>-->
          <angular-slickgrid gridId="grid1"
                             [columnDefinitions]="columnDefinitions"
                             [gridOptions]="gridOptions"
                             (onAngularGridCreated)="angularGridReady($event)"
                             (sgOnCellChange)="onCellChanged($event.detail.eventData, $event.detail.args)"
                             gridWidth="2500"
                             (sgOnSelectedRowsChanged)="handleSelectedRowsChanged($event.detail.eventData, $event.detail.args)"
                             (sgOnClick)="onCellClicked($event.detail.eventData, $event.detail.args)"
                             [dataset]="dataset">
          </angular-slickgrid>

        </div>
      </div>

    </div>

  </div>
</div>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Ticket Id:{{ticketId}} <span class="close" (click)="c()" aria-hidden="true">&times;</span>
    </div>

  </div>
  <div class="modal-body modal-height pad-top-0">
    <mat-tab-group (selectedTabChange)="tabClick($event)">
      <mat-tab *ngIf="!ticketTab" label="Ticket Details">
        <div *ngIf="!ticketTab">
          <div class="row mar-lft-rgt-0">
            <div class="col-md-12 pad-7">
              <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes"
                      (change)="onTicketChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}">
                <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
              </select>
            </div>
          </div>
          <div class="row mar-lft-rgt-0">
            <div class="form-group col-md-2" *ngFor="let field of dynamicFields;" [ngSwitch]="field.fieldType">
              <input *ngSwitchCase="'1'" type="text" class="form-control radius-0 font-13"
                     placeholder="{{field.fieldName}}" [(ngModel)]="field.value">
              <select *ngSwitchCase="'3'" class="form-control radius-0 font-13 " [(ngModel)]="field.value">
                <option *ngFor="let opt of field.values" [value]="opt">{{opt}}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="row mar-lft-rgt-0">
                <span class="type">Status:</span>&nbsp; <span class="status" (click)="statusClick()"
                                                              [hidden]="defaultStatus">{{statusName}}</span>
                <!--&nbsp;<input type="text" class="col-sm-4 radius-0 font-13 formClass" [hidden]="!defaultStatus"-->
                <!--placeholder="Status"> &nbsp;-->
                <select class="custom-select col-sm-4 radius-0 font-13" [(ngModel)]="statusSelected"
                        [hidden]="!defaultStatus" (change)="onStatusChange($event.target.selectedIndex)">
                  <option *ngFor="let stat of status" [value]="stat.id">{{stat.name}}</option>
                </select>&nbsp;
                <button type="button" class="btn btn-primary" (click)="setStatus()"
                        [hidden]="!defaultStatus"><i
                  class="fa fa-check"
                  aria-hidden="true"></i>
                </button>&nbsp;
                <button type="submit" class="btn btn-default" (click)="statusClick()" [hidden]="!defaultStatus"><i
                  class="fa fa-times" aria-hidden="true"></i></button>
              </div>
              <div class="row mar-top-9">
                <div class="form-group row mar-lft-rgt-0">
                  <label class="col-form-label col-sm-2 font-13">Priority</label>
                  <div class="col-sm-10">
                    <input type="text" class="form-control font-13" [disabled]="true" [(ngModel)]="priority"
                           placeholder="Priority">
                  </div>
                </div>
                <div class="form-group col-sm-12">
                  <input type="text" class="form-control radius-0 font-13"
                         placeholder="Enter Requester info (Ex. Name, phone number , email etc)" [(ngModel)]="name">
                </div>
                <div class="form-group col-sm-12">
                  <input type="text" class="form-control radius-0 font-13"
                         placeholder="Ticket description" [(ngModel)]="desc">
                </div>
                <div class="form-group col-sm-12">
                  <textarea class="form-control radius-0 font-13 height-120"
                            placeholder="Brief description" [(ngModel)]="brief"></textarea>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="col-sm">
                <div class="card">
                  <div class="card-header card-header-top font-13">
                    <b>SLA Meter</b>
                    <!--                    <b class="right">Response Time :<span>{{respTime}} min</span></b>-->
                    <b class="right">Resolution Time :<span class="green">{{resoTime}} min</span></b>
                  </div>
                  <div class="card-body row sla-card-pading mar-lft-rgt-0">
                    <div class="col-sm-6">
                      <circle-progress
                        [percent]="percent"
                        [radius]="35"
                        [outerStrokeWidth]="4"
                        [innerStrokeWidth]="2"
                        [showSubtitle]="false"
                        [outerStrokeColor]="outerColor"
                        [innerStrokeColor]="innerColor"
                        [animation]="true"
                        [animationDuration]="300"
                        [startFromZero]="false"
                      ></circle-progress>
                    </div>
                    <div class="col-sm-6 font-13">
                      <p class="sla-meter">SLA Violated:<span [ngClass]="slaViolated?'red':'green'">{{slaString}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm mar-top-9">
                <div class="card">
                  <div class="card-header card-header-top font-13">
                    <b>People</b>
                  </div>
                  <div class="card-body">
                    <div class="row mar-lft-rgt-0">
                      <span class="type">Assigned Group:</span>&nbsp; <span class="status"
                                                                            (click)="nextUserClick('open')"
                                                                            [hidden]="defaultNextUser">{{currentGroup}}</span>

                      &nbsp;<select class="custom-select col-sm-4 radius-0 font-13" [(ngModel)]="supportGroupSelected"
                                    [hidden]="!defaultNextUser" (change)="onGroupChange()">
                      <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
                    </select>&nbsp;
                      <span [hidden]="true">{{assignedGroup}}</span>
                      <span [hidden]="true">{{assignedUser}}</span>
                      <!--<button type="submit" class="btn btn-primary" [hidden]="!defaultNextUser"><i class="fa fa-check"-->
                      <!--aria-hidden="true"></i>-->
                      <!--</button>&nbsp;-->
                      <button type="button" class="btn btn-default" (click)="nextUserClick('close')"
                              [hidden]="!defaultNextUser">
                        <i
                          class="fa fa-times" aria-hidden="true"></i></button>
                    </div>
                    <div class="row mar-top-15 mar-lft-rgt-0">
                      <span class="type">Assigned User:</span>&nbsp; <span class="status" (click)="userClick('open')"
                                                                           [hidden]="defaultUser">{{currentUser}}</span>

                      &nbsp;<select class="custom-select col-sm-4  radius-0 font-13" [hidden]="!defaultUser"
                                    [(ngModel)]="userSelected">
                      <option *ngFor="let user of users" [value]="user.id">{{user.name}}</option>
                    </select>&nbsp;
                      <!--<button type="submit" class="btn btn-primary" [hidden]="!defaultUser"><i class="fa fa-check"-->
                      <!--aria-hidden="true"></i>-->
                      <!--</button>&nbsp;-->
                      <button type="submit" class="btn btn-default" (click)="userClick('close')"
                              [hidden]="!defaultUser">
                        <i
                          class="fa fa-times" aria-hidden="true"></i></button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mar-lft-rgt-0">
            <div class="col-sm-6 pad-15 text-center">
              <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName"
                                       (complete)="onFileComplete($event)"></app-material-fileupload>
            </div>
            <div class="col-sm-6 pad-15 text-center upload-msg" [hidden]="hideAttachment">{{attachMsg}} uploaded
              successfully.Now click Update button to save it
            </div>
            <!--<div class="col-sm-6 pad-15 text-center">{{attachment}}-->
            <!--</div>-->
          </div>
          <div class="row mar-lft-rgt-0">
            <div class="col-sm-6 pad-7">
              <div class="form-group row">
                <label class="col-sm-4 col-form-label font-13">Requested Date</label>
                <div class="col-sm-8">
                  <input [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3"
                         class="form-control radius-0 font-13"
                         [(ngModel)]="rDate">
                  <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
                </div>
              </div>

            </div>
            <div class="col-sm-6 pad-7">
              <div class="form-group row">
                <label class="col-sm-4 col-form-label font-13">Due Date</label>
                <div class="col-sm-8">
                  <input [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4"
                         class="form-control radius-0 font-13"
                         [(ngModel)]="dDate">
                  <owl-date-time [pickerType]="'calendar'" #dt4></owl-date-time>
                </div>
              </div>
            </div>
          </div>
          <div class="row mar-lft-rgt-0">
            <div class="col-sm-4" *ngIf="!closedticket">
              <button type="button" class="btn btn-success radius-0 btn-block"
                      (click)="updateTicket()">Update Ticket
              </button>
            </div>
            <div class="col-sm-4" *ngIf="ticketCreated">
              <button type="button" class="btn btn-danger radius-0 btn-block"
                      (click)="closeTicket()">Close Ticket
              </button>
            </div>
            <div class="col-sm-4" *ngIf="isApprovedTicket">
              <button type="button" class="btn btn-primary radius-0 btn-block"
                      (click)="approveTicket()">Approve/Reject Ticket
              </button>
            </div>
            <div class="col-sm-4" *ngIf="!escalatedTicket ">
              <button type="button" class="btn btn-primary radius-0 btn-block" [disabled]="!assignedToMe "
                      (click)="forwardTicket()">Forward Ticket
              </button>
            </div>

            <div class="col-sm-4" *ngIf="escalatedTicket">
              <button type="button" class="btn btn-primary radius-0 btn-block"
                      (click)="escalateTicket()">Escalate Ticket
              </button>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab *ngIf="!commentsTab" label="Comments">
        <img class="loading-gif" src="../../../assets/img/loader.gif" [hidden]="comLoaded">
        <div class="mar-top-15 ">
          <div class="col-sm-12">
            <div class="form-group col-sm-12">
                  <textarea class="form-control radius-0 font-13 height-120"
                            placeholder="Put your comment here" [(ngModel)]="comment"></textarea>
            </div>
          </div>
          <div class="col-sm-12">
            <button type="button" class="btn btn-success btn-block" (click)="addComment()" [disabled]="!canAddComment">
              Add Comment
            </button>
          </div>
          <div class="col-sm-12 mar-top-15">

            <div class="stepper-container vertical">
              <div class="stepper">
                <div class="step" *ngFor="let comment of comments;">
                  <div class="step-inner">
                    <div class="step-circle"><span><i class="fa fa-user"></i></span></div>
                  </div>
                  <div class="step-content col-sm-12 mar-top-15 mar-lft-rgt-0">
                    <div class="card radius-0">
                      <div class="card-header radius-0 card-header-top stepper-head">
                        <b>{{comment.name}}</b>
                        <b class="right"> {{comment.createddate| date:'medium'}}</b>
                      </div>
                      <div class="card-body">
                        {{comment.feedback}}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab *ngIf="!solTab" label="Solutions">
        <img class="loading-gif" src="../../../assets/img/loader.gif" [hidden]="solLoaded">
        <div class="form-group col-sm-12 mar-top-15">
                  <textarea class="form-control radius-0 font-13 height-120"
                            placeholder="Put your solution here" [(ngModel)]="solution"></textarea>
        </div>
        <!--<div class="form-group col-sm-12">-->
        <!--<textarea class="form-control radius-0 font-13 height-120"-->
        <!--placeholder="Put your rca here" [(ngModel)]="rca"></textarea>-->
        <!--</div>-->
        <div class="col-sm-12">
          <button type="button" class="btn btn-success btn-block" (click)="addSolution()" [disabled]="!canAddSolution">
            Add Solution
          </button>
        </div>
        <div class="col-sm-12 mar-top-15">

          <div class="stepper-container vertical">
            <div class="stepper">
              <div class="step" *ngFor="let solution of solutions;">
                <div class="step-inner">
                  <div class="step-circle"><span><i class="fa fa-user"></i></span></div>
                </div>
                <div class="step-content col-sm-12 mar-top-15 mar-lft-rgt-0">
                  <div class="card radius-0">
                    <div class="card-header radius-0 card-header-top stepper-head">
                      <b>{{solution.name}}</b>
                      <b class="right"> {{solution.createddate | date:'medium'}}</b>
                    </div>
                    <div class="card-body">
                      {{solution.solutions}}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab *ngIf="!attachTab" label="Attachments">
        <table class="table font-13 mar-top-15 attachment">
          <thead class="thead-dark">
          <tr>
            <th>File</th>

            <th>Date</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let attachment of attachments;">
            <td><a href="{{attachment.attacheMent}}" target="_blank">{{attachment.actual_attachedFilePath}}</a></td>
            <td>{{attachment.createDate| date:'medium'}}</td>
          </tr>
          </tbody>
        </table>
      </mat-tab>
      <mat-tab *ngIf="isAsset" label="View Asset Details">
        <div class="form-group mar-top-9">
          <select class="custom-select offset-4 col-sm-4 radius-0 font-13" [(ngModel)]="masterNameSelected"
                  (change)="onMasterChange($event.target.selectedIndex)">
            <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>
          </select>
        </div>
        <div class="col-sm-12 height-386" *ngIf="showGrid">
          <angular-slickgrid gridId="grid2"
                             [columnDefinitions]="columnDefinitions1"
                             [gridOptions]="gridOptions1"
                             (onAngularGridCreated)="angularGridReady1($event)"
                             gridWidth="1800"
                             (sgOnClick)="onCellClicked1($event.detail.eventData, $event.detail.args)"
                             (sgOnSelectedRowsChanged)="handleSelectedRowsChanged1($event.detail.eventData, $event.detail.args)"
                             [dataset]="data">
          </angular-slickgrid>
        </div>
      </mat-tab>
      <mat-tab *ngIf="isAsset" label="Add Asset Details">
        <div class="form-group mar-top-9">
          <select class="custom-select offset-4 col-sm-4 radius-0 font-13" [(ngModel)]="masterDataNameSelected"
                  (change)="onMasterDataChange($event.target.selectedIndex)">
            <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>
          </select>
        </div>
        <div class="col-sm-12 height-386" *ngIf="showGrid1">
          <angular-slickgrid gridId="grid3"
                             [columnDefinitions]="columnDefinitions2"
                             [gridOptions]="gridOptions2"
                             (onAngularGridCreated)="angularGridReady2($event)"
                             gridWidth="1800"
                             (sgOnSelectedRowsChanged)="handleSelectedRowsChanged2($event.detail.eventData, $event.detail.args)"
                             [dataset]="data2">
          </angular-slickgrid>
        </div>
        <button type="button" class="btn btn-primary btn-block radius-0 font-13 col-md-6 offset-4 mar-top-9"
                (click)="saveAssetData()">Save
        </button>
      </mat-tab>
      <mat-tab *ngIf="isViewIncident" label="View Incident">
        <div class="col-sm-12 height-450" *ngIf="showGridForViewIncident">
          <angular-slickgrid gridId="grid3"
                             [columnDefinitions]="columnDefinitions3"
                             [gridOptions]="gridOptions3"
                             (onAngularGridCreated)="angularGridReady3($event)"
                             gridWidth="1800"
                             (sgOnClick)="onCellClicked3($event.detail.eventData, $event.detail.args)"
                             [dataset]="viewIncidentData">
          </angular-slickgrid>
        </div>
      </mat-tab>
      <mat-tab *ngIf="isAddIncident" label="Add Incident">
        <div class="form-inline mar-top-15">
          <div class="form-group offset-4 col-sm-4">
            <label for="ticketId" class="sr-only">Ticket Id</label>
            <input type="text" class="form-control font-13 radius-0" [(ngModel)]="searchTid" id="ticketId"
                   placeholder="Enter Ticket Id">&nbsp;
            <button type="button" class="btn btn-primary font-13 radius-0" (click)="searchTicket()">Search</button>
          </div>

        </div>
        <div class="col-sm-12 height-250" *ngIf="showGridForAddIncident">
          <angular-slickgrid gridId="grid4"
                             [columnDefinitions]="columnDefinitions4"
                             [gridOptions]="gridOptions4"
                             (onAngularGridCreated)="angularGridReady4($event)"
                             gridWidth="2200"
                             (sgOnSelectedRowsChanged)="handleSelectedRowsChanged4($event.detail.eventData, $event.detail.args)"
                             [dataset]="addIncidentData">
          </angular-slickgrid>
        </div>
        <div class="row">
          <button type="button" class="btn btn-success btn-block radius-0 font-13 col-md-6  mar-top-9"
                  (click)="addTicket()">Add Ticket ({{ticketCount}})
          </button>
          <button type="button" class="btn btn-primary btn-block radius-0 font-13 col-md-6  mar-top-9"
                  (click)="saveIncidentData()">Save
          </button>
        </div>
      </mat-tab>
      <mat-tab *ngIf="!logTab" label="Activity Logs">
        <table class="table font-13 mar-top-15 activity">
          <thead class="thead-dark">
          <tr>
            <th>Username</th>
            <th>Action</th>
            <th>Action Description</th>
            <th>Action Date</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let log of logs;">
            <td>{{log.NAME}}</td>
            <td>{{log.activity_desc}}</td>
            <td>{{log.logValue}}</td>
            <td>{{log.createdate| date:'medium'}}</td>
          </tr>
          </tbody>
        </table>
      </mat-tab>
      <mat-tab *ngIf="isRInfo" label="Requestor Info">
        <div class="mar-top-15 ">

          <div class="form-group row">
            <label  class="col-sm-2 col-form-label">Login Name</label>
            <div class="col-sm-10">
              <input type="text" class="form-control radius-0 font-13" [(ngModel)]="loginName" >
            </div>
          </div>
          <div class="form-group row">
            <label  class="col-sm-2 col-form-label">User Name</label>
            <div class="col-sm-10">
              <input type="text" class="form-control radius-0 font-13"  [(ngModel)]="username">
            </div>
          </div>
          <div class="form-group row">
            <label  class="col-sm-2 col-form-label">Email</label>
            <div class="col-sm-10">
              <input type="text" class="form-control radius-0 font-13" [(ngModel)]="email" >
            </div>
          </div>
          <div class="form-group row">
            <label  class="col-sm-2 col-form-label">Mobile</label>
            <div class="col-sm-10">
              <input type="text" class="form-control radius-0 font-13" [(ngModel)]="mobile">
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

</ng-template>
<ng-template #groupSelect>
  <select class="custom-select radius-0 font-13" [(ngModel)]="userGroupSelected" (change)="onSelectGroup()">
    <option *ngFor="let group of userGroups" [value]="group.groupId">{{group.grpName}}</option>
  </select>
</ng-template>
<notifier-container></notifier-container>
